module.exports = __webpack_public_path__ + "static/month_span_pages-1669d6a711116e13a8720e1e38774675.png";